import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
export default class extends Controller {
  static targets = ["list", "input"]
  static values = { group: String }

  connect() {
    console.log("Sortable controller connected", this.listTarget)
    this.sortable = Sortable.create(this.listTarget, {
      group: this.groupValue || "shared",
      animation: 200,
      ghostClass: "opacity-50",
      chosenClass: "shadow-lg",
      dragClass: "rotate-3",
      onEnd: this.onEnd.bind(this)
    })
    console.log("Sortable initialized", this.sortable)
    
    // Listen for custom events to update order when checkboxes change
    this.element.addEventListener('sortable:update-order', this.updateOrder.bind(this))
    
    // Initialize the order on connect
    this.updateOrder()
    this.updatePriorityNumbers()
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  onEnd(event) {
    // Update the hidden input with the new order
    this.updateOrder()
    // Update the priority numbers in the UI
    this.updatePriorityNumbers()
  }

  updateOrder() {
    const items = this.listTarget.children
    const order = []
    
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      const attributeName = item.dataset.attribute
      // Only include visible items (not hidden by unchecking)
      if (attributeName && item.style.display !== 'none') {
        order.push(attributeName)
      }
    }
    
    console.log("Updating order:", order)
    
    // Update the hidden input field - need to create multiple hidden inputs for array parameter
    if (this.hasInputTarget) {
      // Clear existing hidden inputs for ordered_attributes
      const form = this.inputTarget.closest('form')
      if (form) {
        // Remove existing ordered_attributes hidden inputs
        const existingInputs = form.querySelectorAll('input[name="match_type[ordered_attributes][]"]')
        console.log("Removing existing inputs:", existingInputs.length)
        existingInputs.forEach(input => input.remove())
        
        // Create new hidden inputs for each attribute in order
        order.forEach(attribute => {
          const hiddenInput = document.createElement('input')
          hiddenInput.type = 'hidden'
          hiddenInput.name = 'match_type[ordered_attributes][]'
          hiddenInput.value = attribute
          form.appendChild(hiddenInput)
        })
        console.log("Created new inputs for order:", order)
      }
    }
    
    // Dispatch a custom event for other components to listen to
    this.dispatch("orderChanged", { detail: { order: order } })
  }

  updatePriorityNumbers() {
    const items = this.listTarget.children
    let visibleIndex = 1
    
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      const priorityBadge = item.querySelector('.bg-indigo-100, .priority-badge')
      
      if (item.style.display !== 'none' && priorityBadge) {
        priorityBadge.textContent = `#${visibleIndex}`
        visibleIndex++
      }
    }
  }
}